// utils/learningPayloadCrypto.js

// این مقادیر باید با مقادیر تعیین‌شده در سرور هماهنگ باشند
const P1 = "qmEdGLYn_mHiTojvg5C11za1SWVe2Cne";
const P2 = "USFvUT7XzQu_omx04phjxz9s2nZbUilI";
const P3 = "xTCSlCw6UGUBoRM8O81wWkH5dHSX7tjt";

// ترتیب قرارگیری P1/P2/P3 بر اساس selector (اولین کاراکتر key)
const SELECTOR_ORDERS = {
  "1": [P1, P2, P3],
  "2": [P2, P3, P1],
  "3": [P3, P1, P2],
};

const NONCE_LENGTH = 12;
const TAG_LENGTH_BYTES = 16;

const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder("utf-8", { fatal: true });

// Base64 → Uint8Array
const base64ToBytes = (base64) => {
  const binary = window.atob(base64.replace(/\s+/g, ""));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

// ساخت کلید AES-256 از روی orderedKeySource (SHA-256 خروجی UTF-8)
const buildAesKey = async (orderedKeySource) => {
  const hashBuffer = await window.crypto.subtle.digest(
    "SHA-256",
    textEncoder.encode(orderedKeySource)
  );
  return window.crypto.subtle.importKey(
    "raw",
    hashBuffer,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );
};

/**
 * decrypt کردن payload یادگیری API
 *
 * @param {Object} params
 * @param {string} params.key        - کلید حاوی selector (فقط اولین کاراکتر استفاده می‌شود)
 * @param {string} params.payload    - ciphertext به‌صورت Base64
 * @returns {Promise<Object>} data decrypt شده (JSON parse شده)
 */
export const decryptLearningPayload = async ({ key, payload } = {}) => {
  if (!key || typeof key !== "string" || key.length === 0) {
    throw new Error("کلید نامعتبر است");
  }
  if (!payload || typeof payload !== "string" || payload.length === 0) {
    throw new Error("payload نامعتبر است");
  }

  const selector = key[0];
  const orderedParts = SELECTOR_ORDERS[selector];
  if (!orderedParts) {
    throw new Error(`selector نامعتبر است: "${selector}"`);
  }

  const orderedKeySource = orderedParts.join("");

  let data;
  try {
    data = base64ToBytes(payload);
  } catch (error) {
    throw new Error("Base64 decode شکست خورد");
  }

  if (data.length < NONCE_LENGTH + TAG_LENGTH_BYTES) {
    throw new Error("payload طول کافی ندارد");
  }

  // ساختار: [ 12-byte nonce ][ ciphertext ][ 16-byte authentication tag ]
  const nonce = data.subarray(0, NONCE_LENGTH);
  const ciphertextWithTag = data.subarray(NONCE_LENGTH);

  let aesKey;
  try {
    aesKey = await buildAesKey(orderedKeySource);
  } catch (error) {
    throw new Error("ساخت کلید AES ناموفق بود");
  }

  let plaintext;
  try {
    plaintext = await window.crypto.subtle.decrypt(
      { name: "AES-GCM", iv: nonce, tagLength: 128 },
      aesKey,
      ciphertextWithTag
    );
  } catch (error) {
    throw new Error("AES-GCM authentication یا decrypt شکست خورد");
  }

  let parsed;
  try {
    parsed = JSON.parse(textDecoder.decode(plaintext));
  } catch (error) {
    throw new Error("JSON parse شکست خورد");
  }

  return parsed;
};